

















import { defineComponent, PropType } from '@vue/composition-api';

import { Button as MButton } from '@kibt/meta-ui';
import { sendClickLog } from '@/common/log';
import { callApp, CallAppOption } from '../../utils';

import topickIcon from '@/assets/images/topick.png';

export default defineComponent({
    name: 'DetailHeader',
    props: {
        callAppOption: {
            type: Object as PropType<CallAppOption>,
            default: () => ({}),
        },
    },
    components: {
        MButton,
    },
    setup(props) {
        function handleClickBtn() {
            sendClickLog({
                name: 'GUIDE_TOP_BANNER',
            });
            callApp(props.callAppOption);
        }
        return {
            handleClickBtn,
            callApp,

            topickIcon,
        };
    },
});
